import React, { useState } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  collapsSidebar?: boolean;
  showSidebar?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ 
  children,
  title = "",
  showSidebar = true,
  collapsSidebar = false
}) => {

  const [sidebarToggle, setSidebarToggle] = useState(false);
  
  return (
    <div className="min-h-screen bg-surface-cool">
      <div className="flex">
        {/* Sidebar */}
        {showSidebar && (
          <Sidebar 
            className="h-screen hidden md:flex" 
            defaultCollapsed={collapsSidebar}
          />
        )}

        {/* Mobile Sidebar Overlay */}
        {sidebarToggle && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={() => setSidebarToggle(false)}
          />
        )}

        {/* Mobile Sidebar */}
        {showSidebar && (
          <div 
            className={`fixed top-0 left-0 h-full  bg-white shadow-lg z-[80] transform transition-transform duration-300 ease-in-out md:hidden ${
              sidebarToggle ? 'translate-x-0' : '-translate-x-full'
            }`}
          >
            <Sidebar 
              className="h-full" 
              onMobileNavigation={() => setSidebarToggle(false)}
            />
          </div>
        )}
        
        {/* Main Content */}
        <div 
          className="transition-all duration-300 ease-in-out flex flex-col h-screen flex-[1_1_auto] overflow-auto my-scrollbar" 
        >
          {/* Header */}
          <Header 
            title={title}
            className="sticky top-0 z-20"
            toggleSidebar={() => setSidebarToggle(prev => !prev)}
          />
          
          {/* Page Content */}
          <main className="flex-1 p-4 pt-2 route-fade-in">
            {children}
          </main>
        </div>
      </div>

    </div>
  );
};

export default MainLayout;

